import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: string;
  message: string;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  public toasts$ = this.toastsSubject.asObservable();

  private toastIdCounter = 0;
  private readonly TOAST_DURATION = 1500; // 1.5 seconds

  showToast(message: string): void {
    const toast: Toast = {
      id: `toast-${++this.toastIdCounter}`,
      message,
      timestamp: Date.now()
    };

    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([...currentToasts, toast]);

    // Auto-remove toast after duration
    setTimeout(() => {
      this.removeToast(toast.id);
    }, this.TOAST_DURATION);
  }

  removeToast(id: string): void {
    const currentToasts = this.toastsSubject.value;
    const filteredToasts = currentToasts.filter(toast => toast.id !== id);
    this.toastsSubject.next(filteredToasts);
  }

  clearAllToasts(): void {
    this.toastsSubject.next([]);
  }
}